import { Component } from '@angular/core';
import {DashboardLayoutComponent} from "../../layouts/dashboard-layout/dashboard-layout.component";
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    DashboardLayoutComponent,
    RouterOutlet
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent {

}
